<template>
<card :image="true" :footer="true">
<template slot="image">
  <figure class="image is-5by1 background-image"
      :style="{ backgroundImage: 'url(' + coverImage + ')' }">
  <button v-if="isWidget" class="button" @click="goBack" >
    <hv-image size="" :is-rounded="false" :src="favouriteStarUrl">
    </hv-image>
  </button>
</figure>
</template>
<columns v-if="job">
  <column></column>
  <column>
    <div class="is-relative">
      <router-link :to="hirerUrl">
        <hv-image v-if="job" size="is-96x96" :is-centered="true" @click="onCompanyClick" class="border-white-3px job-image"
          :src="companyImage" alt="Job Image" >
          <status-indicator v-if="job.applicationStatus" :status="job.applicationStatus" :date="job.applicationUpdatedAt" size="is-24"/>
        </hv-image>
      </router-link>
    </div>
  </column>
  <column>
    <div class="salary">
      <h2 class="title is-5" >
        <job-salary :job="job" />
      </h2>
    </div>
    <applicant-refrrer class="job-detail-applicant-referrer m-t-12" :job="job" />
  </column>
</columns>
<div class="media" v-if="job">
  <div class="media-content has-text-centered">
    <p class="title is-4">{{ job.title }}</p>
    <p class="break-text m-b-8">
      <span v-if="job.jobCategoryName">{{job.jobCategoryName}} • </span> {{ getContract(jobTypeName) | capitalize }}</p>
    <p class="break-text">
      <span v-if="job.companyName">{{ job.companyName }} •</span>
      <job-location :locations="job.locations" :remote="job.isRemoteAvailable"></job-location>
    </p>
  </div>
</div>
<template slot="footer">
  <split-section v-if="job">
    <template slot="left">
      <div class="has-text-centered">
        <reward :isSourceJp="isSourceJp" :fiatReward="fiatReward" :min="rewardMin" :max="rewardMax"  :currency="job.salaryCurrency" :rewardPercentage="job.rewardPercentage"  :cssClass="'title is-5'" />
      </div>
    </template>
    <template slot="right">
      <div class="has-text-centered">
        <charity :jobSource="job.source" :fiatReward="job.fiatReward" :rewardPercentage="job.rewardPercentage" :minReward="rewardMin" :maxReward="rewardMax" :min="charityMin" :max="charityMax" :currency="job.salaryCurrency" :cssClass="'title is-5'" />
      </div>
    </template>
  </split-section>
</template>
</card>
</template>

<script>
import Card from '@/components/general/card'
import HvImage from '@/components/general/image'
import FavouriteStar from '@/assets/back-arrow.svg'
import SplitSection from '@/components/general/split-section'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import _ from 'lodash'
import Currency from '@/components/general/currency'
import JobSalary from '@/components/general/job-salary'
import JobLocation from '@/components/jobs/job-locations'
import Reward from './reward'
import Charity from '@/components/jobs/charity'
import RewardHelper from '@/helpers/reward'
import StatusIndicator from '@/components/jobs/job-status-indicator'
import ApplicantRefrrer from '@/components/jobs/applicant_and_referrer'
import JobHelper from '@/helpers/job'
import DefaultCoverImage from '@/assets/header-default.png'

export default {
  components: {
    HvImage,
    Card,
    SplitSection,
    Columns,
    Column,
    Currency,
    JobSalary,
    JobLocation,
    Reward,
    Charity,
    StatusIndicator,
    ApplicantRefrrer
  },
  data () {
    return {
      minimum: null,
      maximum: null
    }
  },
  props: {
    job: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    hirerUrl () {
      return this.$route.meta.hasOwnProperty('widgetMode') ? `/widget/hirer/${this.job.companyId}` : `/hirer/${this.job.companyId}`
    },
    jobTypeName () {
      return this.job.jobTypeName || this.job.contract
    },
    hasSalary () {
      return JobHelper.hasSalary(this.job)
    },
    fiatReward () {
      return this.job.hasOwnProperty('fiatReward') ? this.job.fiatReward : 0
    },
    isSourceJp () {
      return this.job.hasOwnProperty('source') && this.job.source === 'jp'
    },
    favouriteStarUrl () {
      return FavouriteStar
    },
    charityMin () {
      if (this.minimum) {
        return this.minimum.charity
      }
      return 0
    },
    charityMax () {
      if (this.maximum) {
        return this.maximum.charity
      }
      return 0
    },
    rewardMin () {
      if (this.minimum) {
        return this.minimum.user
      }
      return 0
    },
    rewardMax () {
      if (this.maximum) {
        return this.maximum.user
      }
      return 0
    },
    companyImage () {
      return this.job.companyImageUrl || `/api/identicons/${this.job.companyId}`
    },
    coverImage () {
      return this.job.companyCoverImageUrl || DefaultCoverImage
    },
    isWidget () {
      return !!this.$route.meta.hasOwnProperty('widgetMode')
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    calcReward () {
      const rewardPercentage = this.job.rewardPercentage
      const maxReward = this.job.maxReward
      const minReward = this.job.minReward
      RewardHelper.calcPercentage(rewardPercentage)
      this.maximum = RewardHelper.calc(rewardPercentage, maxReward)
      this.minimum = RewardHelper.calc(rewardPercentage, minReward)
    },
    getContract (v) {
      const value = v.toLowerCase()
      if (value === 'contract') {
        return this.$t('jobs.roleContract')
      } else if (value === 'permanent') {
        return this.$t('jobs.rolePermanent')
      } else if (value === 'freelance') {
        return this.$t('jobs.roleFreelance')
      }
      return value
    },
    onCompanyClick () {
      if (this.isWidget) {
        this.$router.push(`/widget/hirer/${this.job.companyId}`)
      } else {
        this.$router.push(`/hirer/${this.job.companyId}`)
      }
    }
  },
  filters: {
    capitalize (value) {
      return _.capitalize(value)
    }
  },
  mounted () {
    this.calcReward()
  }
}
</script>

<style lang="scss" scoped>
.card-image {
  border-bottom: inherit;
}

.card-footer {
  padding: 1rem;
  p {
    text-align: center;
    width: 100%;
  }
}

.card-content figure.job-image {
  margin-top: -4rem;
  margin-bottom: -2rem;
}

.media {
  p.title {
    margin-bottom: 1rem;
  }
}

.image.is-circular {
  border: solid white 3px;
}

.image.is-5by1 {
  padding-top: 18.5%;

  .button {
    float: left;
    margin-top: calc(-18.5% + 15px);
    margin-left: 15px;
    font-weight: normal !important;
    text-transform: none;
    z-index: 5;
  }

  .mr{
    margin-right: 10px;
  }

  & > img {
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
  }
}

.background-image {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-position: bottom;
  background-size: cover;
}

.salary {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  min-height: 20px;
  .title.is-5 {
    font-size: 1.125rem;
  }
}

.media-content {
  p:last-child {
    margin-top: 0.5rem;
  }
}

.job-detail-applicant-referrer {
  position: absolute;
  right: 14px;
}

/deep/ .location {
  display: inline !important;
}

</style>



// WEBPACK FOOTER //
// src/components/jobs/job-details-card.vue